import Vue from "vue";
import Vuex from "vuex";
import generalService from "../api/general";

Vue.use(Vuex);

const initialState = {
  bookmarks: {items: []},
  likeList: [],
};
const getters = {
  bookmarks(state) {
    return state.bookmarks;
  },
  likeList(state) {
    return state.likeList;
  },
  //   comment: "testingggg"
  // dateOfCreate: "2022-03-23T11:24:39.107Z"
  // id: 5
  // image: null
  // imageCommentReports: []
  // imageId: 2
  // reported: null
  // userId: 1
};

export const actions = {
  async deleteComment(context, payload) {
    try {
      const response = await generalService.deleteComment(payload);
      return Promise.resolve();
    } catch (error) {
      const toastMessage =
        context.rootState.langObj.response.error.somethingWentWrong;
      const toastColor = "red lighten-2";
      context.commit(
        "toast",
        { message: toastMessage, color: toastColor },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async updateComment(context, payload) {
    try {
      const response = await generalService.updateComment(payload);
      return Promise.resolve();
    } catch (error) {
      const toastMessage =
        context.rootState.langObj.response.error.somethingWentWrong;
      const toastColor = "red lighten-2";
      context.commit(
        "toast",
        { message: toastMessage, color: toastColor },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async insertComment(context, payload) {
    try {
      const response = await generalService.insertComment(payload);
      return Promise.resolve();
    } catch (error) {
      const toastMessage =
        context.rootState.langObj.response.error.somethingWentWrong;
      const toastColor = "red lighten-2";
      context.commit(
        "toast",
        { message: toastMessage, color: toastColor },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async addBookmark(context, payload) {
    try {
      const response = await generalService.addBookmark(payload);
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async deleteBookmark(context, payload) {
    try {
      const response = await generalService.deleteBookmark(payload);
      return Promise.resolve();
    } catch (error) {
      const toastMessage =
        context.rootState.langObj.response.error.somethingWentWrong;
      const toastColor = "red lighten-2";
      context.commit(
        "toast",
        { message: toastMessage, color: toastColor },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async getBookmarks(context, payload) {
    try {
      const response = await generalService.getBookmarks(payload);
      context.state.bookmarks = response.data;
      return Promise.resolve();
    } catch (error) {
      context.commit(
        "toast",
        {
          message: context.rootState.langObj.response.error.somethingWentWrong,
          color: "red lighten-2",
        },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async addLike(context, payload) {
    try {
      const response = await generalService.addLike(payload);
      return Promise.resolve();
    } catch (error) {
      const toastMessage =
        context.rootState.langObj.response.error.somethingWentWrong;
      const toastColor = "red lighten-2";
      context.commit(
        "toast",
        { message: toastMessage, color: toastColor },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async deleteLike(context, payload) {
    try {
      const response = await generalService.deleteLike(payload);
      return Promise.resolve();
    } catch (error) {
      const toastMessage =
        context.rootState.langObj.response.error.somethingWentWrong;
      const toastColor = "red lighten-2";
      context.commit(
        "toast",
        { message: toastMessage, color: toastColor },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
  async viewLikes(context, payload) {
    try {
      const response = await generalService.viewLikes({ userIds: payload });
      var likeList = [];
      for (const key in response.data.dict) {
        if (Object.hasOwnProperty.call(response.data.dict, key)) {
          const element = response.data.dict[key];
          likeList.push(element);
        }
      }
      context.state.likeList = likeList;
      return Promise.resolve();
    } catch (error) {
      const toastMessage =
        context.rootState.langObj.response.error.somethingWentWrong;
      const toastColor = "red lighten-2";
      context.commit(
        "toast",
        { message: toastMessage, color: toastColor },
        { root: true }
      );
      return Promise.reject(error);
    }
  },
};

export const state = { ...initialState };

export default {
  namespaced: true,
  state,
  getters,
  actions,
};
